import { render } from "./VariationReport.vue?vue&type=template&id=1ab843e3"
import script from "./VariationReport.vue?vue&type=script&lang=js"
export * from "./VariationReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__